<template>
  <div class="page">

    <!-- 搜索 -->
    <el-form v-if="isShowSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
      <el-form-item label="用户">
        <GridSelect
          style="width: 200px"
          title="选择用户"
          labelName="userName"
          labelValue="id"
          :value="queryForm.userId"
          :limit="1"
          size="small"
          placeholder="请选择用户"
          @getValue="(value) => { queryForm.userId = value }"
          :columns="USER_code"
          :searchs="USER_search"
          dataListUrl="/mpp/user/findList"
          entityBeanName="mppUser"
          queryEntityUrl="/mpp/user/get"
        ></GridSelect>
      </el-form-item>
      <el-form-item label="业绩区间">
          <el-date-picker
              style="width: 180px"
              v-model="timeRange"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          >
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopUserReportList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 页面内容 -->
    <div class="page-content">
      <div class="page-tool-bar">

        <!-- 批量操作 -->
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addShopUserReport"
          >新建</el-button>
          <el-button
            type="warning"
            plain
            size="small"
            icon="el-icon-edit"
            :disabled="multipleSelection.length != 1"
            @click="editShopUserReport(null)"
          >修改</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteShopUserReport(null)"
          >删除</el-button>
        </div>

        <!-- 导入导出查询 -->
        <div class="icon-group">
          <el-upload v-if="this.isShowImport"
            class="upload-demo"
            action="#"
            :http-request="importShopUserReportData"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span
            title="搜索"
            class="icon-box"
            @click="showHiddenSearch">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
      
          
         
          </span>
          <span
            class="icon-box"
            @click="refreshShopUserReportList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>

      <!-- 分页列表 -->
      <el-table
        :data="shopUserReportList"
        row-key="id"
        border
        height="100%"
        :header-row-style="{height: '10px'}"
        :header-cell-style="{padding: '10px'}"
        :row-style="{height: '9px'}"
        :cell-style="{padding: '9px'}"
        @selection-change="handleSelectionChange"
        size="small">
        <el-table-column
          align="center"
          type="selection"
          width="60">
        </el-table-column>
        <el-table-column
          align="center"
          label="用户信息"
          width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
              <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
              <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
              <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
              <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="personalPerformance"
          label="个人业绩"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="teamPerformance"
          label="团队业绩"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="personalServiceFee"
          label="个人让利"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="teamServiceFee"
          label="团队让利"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="smallPerformance"
          label="小区业绩"
          width="180">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="创建时间"
          width="180">
        </el-table-column>
        <el-table-column
          fixed="right"
          align="center"
          label="操作"
          width="340">
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopUserReport(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopUserReport(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopUserReport(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
              <div @click="showRecordDrawer(scop.row.userId)">
                <Icon size="16">
                  <TextBulletListSquare24Regular />
                </Icon>
                <span class="operation-label">记录</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7">
        </el-pagination>
      </div>

      <!-- 新增/查看/修改 -->
      <el-dialog
        :title="shopUserReportStates[shopUserReportState]"
        :visible.sync="showDialog"
        width="60%"
        @close="closeDialog">
        <div>
          <el-form
            :model="shopUserReport"
            ref="shopUserReportForm"
            :rules="rules"
            label-width="120px"
            :inline="true"
            size="small">
            <el-form-item
              label="用户"
              prop="userId"
              v-if="
                shopUserReportState == 'add' ||
                shopUserReportState == 'check' ||
                shopUserReportState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReport.userId"
                :disabled="shopUserReportState == 'check'"
                placeholder="请输入用户"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="个人业绩"
              prop="personalPerformance"
              v-if="
                shopUserReportState == 'add' ||
                shopUserReportState == 'check' ||
                shopUserReportState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReport.personalPerformance"
                :disabled="shopUserReportState == 'check'"
                placeholder="请输入个人业绩"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="团队业绩"
              prop="teamPerformance"
              v-if="
                shopUserReportState == 'add' ||
                shopUserReportState == 'check' ||
                shopUserReportState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReport.teamPerformance"
                :disabled="shopUserReportState == 'check'"
                placeholder="请输入团队业绩"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="个人让利"
              prop="personalServiceFee"
              v-if="
                shopUserReportState == 'add' ||
                shopUserReportState == 'check' ||
                shopUserReportState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReport.personalServiceFee"
                :disabled="shopUserReportState == 'check'"
                placeholder="请输入个人让利"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="团队让利"
              prop="teamServiceFee"
              v-if="
                shopUserReportState == 'add' ||
                shopUserReportState == 'check' ||
                shopUserReportState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReport.teamServiceFee"
                :disabled="shopUserReportState == 'check'"
                placeholder="请输入团队让利"
                style="width: 200px;">
              </el-input>
            </el-form-item>
            <el-form-item
              label="小区业绩"
              prop="smallPerformance"
              v-if="
                shopUserReportState == 'add' ||
                shopUserReportState == 'check' ||
                shopUserReportState == 'edit' ||
                false
              ">
              <el-input
                size="small"
                v-model="shopUserReport.smallPerformance"
                :disabled="shopUserReportState == 'check'"
                placeholder="请输入小区业绩"
                style="width: 200px;">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div
          slot="footer"
          class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="shopUserReportState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog>

      <!-- 右侧记录抽屉 -->
      <el-drawer
        title="用户报表记录"
        :visible.sync="recordDrawerVisible"
        direction="rtl"
        size="70%"
        :before-close="closeRecordDrawer">
        <ShopUserReportRecord :userId="currentRecordUserId" ref="ShopUserReportRecord"></ShopUserReportRecord>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular, TextBulletListSquare24Regular } from '@v2icons/fluent';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { downloadTemplate, importData, exportExcel, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelect from '@/components/gridselect';
import { USER, USER_SEARCH } from '@/utils/constant';
import ShopUserReportRecord from './ShopUserReportRecord.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        TextBulletListSquare24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect,
        ShopUserReportRecord
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopUserReportList();
                this.getShopUserReportList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopUserReportList();
                this.getShopUserReportList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            timeRange: [],
            queryForm: {
                userId: '',
                startTime: '',
                endTime: '',
            },
            loading: false,
            showDialog: false,
            recordDrawerVisible: false,
            currentRecordUserId: '',
            isShowSearch: false,
            isShowImport: false,
            downloadLoading: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopUserReportState: 'add',
            shopUserReportStates: {
                add: '新建shop_user_report',
                check: '查看shop_user_report',
                edit: '修改shop_user_report'
            },
            multipleSelection: [],
            shopUserReportList: [],
            shopUserReport: {
                id: '', // 
                userId: '', // 用户
                personalPerformance: '', // 个人业绩
                teamPerformance: '', // 团队业绩
                personalServiceFee: '', // 个人让利
                teamServiceFee: '', // 团队让利
                smallPerformance: '', // 小区业绩
                createUserId: '', // 
                createTime: '', // 
                updateUserId: '', // 
                updateTime: '', // 
                deleteFlag: '', // 
            },
            //下拉/单选/复选框选项，可绑定字典或接口填充
            //文件列表
            rules: {
                userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                personalPerformance: [{ required: true, message: '个人业绩不能为空', trigger: 'blur' }],
                teamPerformance: [{ required: true, message: '团队业绩不能为空', trigger: 'blur' }],
                personalServiceFee: [{ required: true, message: '个人让利不能为空', trigger: 'blur' }],
                teamServiceFee: [{ required: true, message: '团队让利不能为空', trigger: 'blur' }],
                smallPerformance: [{ required: true, message: '小区业绩不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getShopUserReportList();
    },
    methods: {
        showHiddenSearch(){
            this.isShowSearch = !this.isShowSearch;
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.getShopUserReportList();
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getShopUserReportList();
        },
        resetShopUserReportList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopUserReportList = [];
        },
        resetDialog() {
            this.shopUserReportState = 'add';
            this.showDialog = false;
            this.timeRange = [];
            this.queryForm = {
                userId: '',
                startTime: '',
                endTime: '',
            };
            this.getShopUserReportList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopUserReport = {
                id: '',
                userId: '',
                personalPerformance: '',
                teamPerformance: '',
                personalServiceFee: '',
                teamServiceFee: '',
                smallPerformance: '',
                createUserId: '',
                createTime: '',
                updateUserId: '',
                updateTime: '',
                deleteFlag: '',
            };
        },
        submitForm() {
            if (this.shopUserReportState == 'add') {
                this.$refs.shopUserReportForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/userreport/add`,{ ...this.shopUserReport }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetShopUserReportList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopUserReportState == 'edit') {
                this.$refs.shopUserReportForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/userreport/edit`,{ ...this.shopUserReport }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopUserReportList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopUserReport() {
            this.showDialog = true;
            this.shopUserReportState = 'add';
        },
        checkShopUserReport(shopUserReportId) {
            console.log(shopUserReportId);
            this.currentShopUserReportId = shopUserReportId;

            this.getShopUserReportById();
            this.showDialog = true;
            this.shopUserReportState = 'check';
        },
        editShopUserReport(shopUserReportId) {
            console.log('shopUserReport', shopUserReportId);
            if (shopUserReportId) {
                this.currentShopUserReportId = shopUserReportId;
                this.getShopUserReportById();
            } else {
                this.shopUserReport = { ...this.shopUserReport, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopUserReportState = 'edit';
        },
        deleteShopUserReport(shopUserReportId) {
            let ids = '';
            if (shopUserReportId) {
                ids = shopUserReportId;
            } else {
                ids = this.multipleSelection.map((shopUserReport) => shopUserReport.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/userreport/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopUserReportList();
                            this.getShopUserReportList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopUserReportList() {
            this.resetShopUserReportList();
            this.getShopUserReportList();
        },
        getShopUserReportList(query = {}) {
            this.loading = true;
            if (this.timeRange != null) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            }
            get(`/shop/userreport/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopUserReportList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopUserReportById() {
            get(`/shop/userreport/get`,{ id: this.currentShopUserReportId }).then((res) =>{
                if(res.success){
                  this.shopUserReport = { ...this.shopUserReport, ...res.shopUserReport };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        //下载模板
        downloadTemplate() {
            this.downloadLoading = true;
            downloadTemplate(`/shop/userreport/downloadTemplate`, this.downloadLoading);
        },
        //导出数据
        exportShopUserReportList() {
            //this.downloadLoading = true;
            exportExcel(`/shop/userreport/export`, {...this.queryForm});
        },
        //导入数据
        showImportData() {
            this.isShowImport = !this.isShowImport;
        },
        importShopUserReportData(params){
          const file = params.file;
          const formData = new FormData();
          formData.append('file', file);
          console.log({ formData });
          importData(`/shop/userreport/import`,formData);
          this.refreshShopUserReportList();
        },
        showRecordDrawer(userId) {
            this.currentRecordUserId = '';
            this.recordDrawerVisible = true;
            this.$nextTick(() => {
                this.currentRecordUserId = userId;
            });
        },
        closeRecordDrawer() {
            this.recordDrawerVisible = false;
            this.currentRecordUserId = '';
        },

    }

};
</script>

<style lang="scss" scoped>

::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
    .operation-label {
        margin-left: 3px;
    }
}

//上传图片相关-------->start
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
//上传图片相关-------->end

</style>